export class TimeoutError extends Error {
  public readonly name = 'TimeoutError';

  constructor(message: string) {
    super(message);
  }
}

/**
 * Standard timeout for Supabase auth operations (refreshSession, etc.)
 * 10s allows for slow networks and Supabase load; the getSession bug
 * (which could hang indefinitely) is worked around by using refreshSession.
 */
export const AUTH_TIMEOUT_MS = 10000;

/**
 * Resolve a promise within `ms` or reject with TimeoutError.
 *
 * Use this to prevent UI deadlocks if an SDK call hangs in production.
 */
export function withTimeout<T>(promise: Promise<T>, ms: number, label = 'operation'): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  const timeoutPromise = new Promise<T>((_, reject) => {
    timeoutId = setTimeout(() => {
      reject(new TimeoutError(`${label} timed out after ${ms}ms`));
    }, ms);
  });

  return Promise.race([promise, timeoutPromise]).finally(() => {
    if (timeoutId) clearTimeout(timeoutId);
  });
}
